import * as Rollbar from "@/lib/rollbar";
import InertiaWrapper from "@/shared/InertiaWrapper.vue";
import { upperFirst } from "es-toolkit";
import { type DefineComponent } from "vue";

//
// all pages
// note - this file must be reloaded whenever a page is added on disk?
//

const PAGES = import.meta.glob<DefineComponent>("../pages/**/*Page.vue");

//
// aliases from action_path to page
//

const ALIASES: Record<string, string> = {
  "alerts/Create": "alerts/Update",
};

export async function resolve(component: string): Promise<DefineComponent> {
  // Convert to camel case
  component = component.replace(/[^/]+$/, (s) => upperFirst(camelCase(s)));
  component = ALIASES[component] || component;
  const klass = `${component}Page.vue`;

  const promise = PAGES[`../pages/${klass}`];
  if (!promise) {
    // html
    const msg = `Whoops, page "${component}" => "${klass}" not found.`;
    renderFallbackError(msg);

    // rollbar and bail
    const ex = new Error(msg);
    Rollbar.error(ex);
    throw ex;
  }

  const page = await promise();
  // note: we no longer support pages with custom inertia wrappers
  page.default.layout = InertiaWrapper;
  return page;
}

function renderFallbackError(msg: string) {
  const div = document.createElement("div");
  div.classList.add(..."mt-40 flex flex-col gap-4 text-center text-harsh-error".split(" "));
  div.textContent = msg;
  document.body.appendChild(div);
}
